module.exports = __webpack_public_path__ + "img/P57-en.e2f10025.png";